import {TypeLocalNameEnum} from 'domain/usecases';
import {CurrentAppointmentLocationStateType} from './types';

const DEFAULT_LOCATION: CurrentAppointmentLocationStateType = {
	state: {cdUf: '', nmUf: ''},
	city: '',
	typeLocalName: TypeLocalNameEnum.CIDADE,
	reference: '',
};

const DEFAULT_ODONTO_LOCATION: CurrentAppointmentLocationStateType = {
	state: {cdUf: '', nmUf: ''},
	city: '',
};

const DEFAULT_EXAM_LOCATION: CurrentAppointmentLocationStateType = {
	state: {cdUf: '', nmUf: ''},
	city: '',
	typeLocalName: TypeLocalNameEnum.CIDADE,
	reference: '',
};

const DEFAULT_AUTHORIZATION_LOCATION: CurrentAppointmentLocationStateType = {
	state: {cdUf: '', nmUf: ''},
	city: '',
};

enum FlowType {
	DEFAULT = 'default',
	ODONTO = 'odonto',
	EXAM = 'exam',
	AUTHORIZATION = 'authorization',
	HEALTH_GUIDE = 'healthGuide',
	ODONTO_GUIDE = 'odontoGuide',
}

const COOKIE_NAMES: Record<FlowType, (cdPessoa: string) => string> = {
	[FlowType.DEFAULT]: cdPessoa => `currentLocation_${cdPessoa}`,
	[FlowType.ODONTO]: cdPessoa => `currentLocation_${cdPessoa}`,
	[FlowType.EXAM]: cdPessoa => `currentLocation_${cdPessoa}`,
	[FlowType.AUTHORIZATION]: cdPessoa => `currentLocationAuthorization_${cdPessoa}`,
	[FlowType.HEALTH_GUIDE]: cdPessoa => `currentHealthGuideLocation_${cdPessoa}`,
	[FlowType.ODONTO_GUIDE]: cdPessoa => `currentOdontoGuideLocation_${cdPessoa}`,
};

export {
	DEFAULT_LOCATION,
	DEFAULT_AUTHORIZATION_LOCATION,
	DEFAULT_EXAM_LOCATION,
	DEFAULT_ODONTO_LOCATION,
	COOKIE_NAMES,
	FlowType,
};
